import { render } from "./ContactInfo.vue?vue&type=template&id=03b39d81&scoped=true"
const script = {}

import "./ContactInfo.vue?vue&type=style&index=0&id=03b39d81&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-03b39d81"]])

export default __exports__